import TouquesJanuary2025 from "../../components/before-after/TouquesJanuary2025";

const TouquesJanuary2025View = () => {

    return (
        <div className="before-after-villers-january-2025">
            <TouquesJanuary2025/>
        </div>
    );
};

export default TouquesJanuary2025View;